import React, { Component } from 'react';
import GeneralComments from '../../../../GeneralComponents/ChatBoxModuleComment'
import Preloader from '../../../../GeneralComponents/LoadingComponen'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FormCreate from '../../../tasks/tasksCard/FormCreate'
import TaskList from '../../../tasks/tasksCard/TaskList'
import ReactHtmlParser from 'react-html-parser';
import IndexTaskModule from '../../../tasks/taskBoard/IndexTaskModule'

class ShowMejora extends Component {
    constructor(props){
        super(props)
        this.url_source = `/risk/matrices/${this.props.risk_matrix.id}/risks/${this.props.risk.id}`,
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            showForm: false,
            activeTab: 'tareas',

            //states task

            selectedOption: {
                user_owner_id: "",
                label: "Responsable"
            },

            users: [],

            form: {
                name: "",
                due_date: "",
                user_owner_id: "",
                url_source: this.url_source,
                task_source_id: this.props.task_source.id,
                module_task_id: this.props.risk.module_task_id,
                name_module: "",
            },
        }
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    //tasks 

    componentDidMount = () => {
        let array = []

        this.props.users.map((item) => (
            array.push({ label: item.name, value: item.id })
        ))

        this.setState({
            users: array
        })
    }

    handleChangeAutocomplete = selectedOption => {
        this.setState({
            selectedOption,
            form: {
                ...this.state.form,
                user_owner_id: selectedOption.value
            }
        });
    };

    clearValues = () => {
        this.setState({
            showForm: false,
            form: {
                ...this.state.form,
                name: "",
                due_date: "",
                user_owner_id: "",
                module_task_id: this.props.risk.module_task_id,
            },

            selectedOption: {
                user_owner_id: "",
                label: "Responsable"
            },
        })
    }

    HandleChangeTask = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            }
        });
    }


    getColor = (number) => {
        if(number == 0 || number >= 12){
            return ["#FF0000","white"]
        }else if(number >= 6 && number <= 11){
            return ["#FFFF00","black"]
        }else if(number == 5 || number < 5){
            return ["#008000","white"]
        }
    }

    getColorImp = (number) => {
        if(number ==1){
            return ["white","black"]
        }else if(number ==2){
            return ["#00B050","black"]
        }else if(number ==3){
            return ["#FFC000","black"]
        }else if(number ==4){
            return ["#FF1300","white"]
        }else if(number ==5){
            return ["#921503","white"]
        }
        
        
    }




    render() {
        const estados = {
            gestionar: true,
            eliminar: true,
        }


        return (
            <React.Fragment>
                {/* ===== Header card ===== */}
                <div className="rk-head">
                    <div className="rk-head__icon">
                        <i className="fas fa-toolbox"></i>
                    </div>
                    <div>
                        <h2 className="rk-head__title">{`${this.props.risk.risk_type}: ${this.props.risk.description}`}</h2>
                        <p className="rk-head__subtitle">Gestión de riesgos</p>
                    </div>
                    <a
                        href={`/risk/matrices/${this.props.risk_matrix.id}/risks`}
                        className="rk-head__back"
                        data-turbolinks="true"
                    >
                        <i className="fas fa-arrow-left"></i> Volver a riesgos
                    </a>
                </div>

                {/* ===== Breadcrumb ===== */}
                <nav className="rk-breadcrumb" aria-label="breadcrumb">
                    <a href={"/risk/matrices"} data-turbolinks="true">
                        <i className="fas fa-th"></i> Matriz de riesgos y oportunidades
                    </a>
                    <span className="rk-breadcrumb__sep">/</span>
                    <a href={`/risk/matrices/${this.props.risk_matrix.id}/risks`} data-turbolinks="true">
                        Riesgos
                    </a>
                    <span className="rk-breadcrumb__sep">/</span>
                    <span className="rk-breadcrumb__current">{`${this.props.risk_matrix.proceso}`}</span>
                </nav>

                {/* ===== Datos del riesgo ===== */}
                <div className="rk-info">
                    <div className="rk-info-grid">
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Reporta</div>
                            <div className="rk-info-field__value">{this.props.risk.user.first_name} {this.props.risk.user.first_last_name}</div>
                        </div>
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Tipo de riesgo</div>
                            <div className="rk-info-field__value">{this.props.risk.risk_type}</div>
                        </div>
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Cargo</div>
                            <div className="rk-info-field__value">{this.props.risk.criterio.name}</div>
                        </div>
                    </div>

                    <div className="rk-scores">
                        <div className="rk-score">
                            <div className="rk-score__label">Probabilidad</div>
                            <span className="rk-score__badge" style={{ backgroundColor: this.getColorImp(this.props.risk.probability)[0], color: this.getColorImp(this.props.risk.probability)[1] }}>{this.props.risk.probability}</span>
                        </div>
                        <div className="rk-score__op">×</div>
                        <div className="rk-score">
                            <div className="rk-score__label">Impacto</div>
                            <span className="rk-score__badge" style={{ backgroundColor: this.getColorImp(this.props.risk.impact)[0], color: this.getColorImp(this.props.risk.impact)[1] }}>{this.props.risk.impact}</span>
                        </div>
                        <div className="rk-score__op">=</div>
                        <div className="rk-score rk-score--total">
                            <div className="rk-score__label">Nivel de riesgo</div>
                            <span className="rk-score__badge rk-score__badge--lg" style={{ backgroundColor: this.getColor(this.props.risk.score)[0], color: this.getColor(this.props.risk.score)[1] }}>{this.props.risk.score}</span>
                        </div>
                    </div>

                    <div className="rk-info-grid rk-info-grid--bottom">
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Posible Afectación</div>
                            {this.props.risk.possible_involvement_array.length > 0 ? (
                                <div className="rk-chips">
                                    {this.props.risk.possible_involvement_array.map((possible, i) => (
                                        <span className="rk-chip" key={i}>{possible}</span>
                                    ))}
                                </div>
                            ) : (
                                <div className="rk-info-field__value text-muted">—</div>
                            )}
                        </div>
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Actividad</div>
                            <div className="rk-info-field__value">{this.props.risk.activity.name}</div>
                        </div>
                        <div className="rk-info-field">
                            <div className="rk-info-field__label">Tarea</div>
                            <div className="rk-info-field__value">{this.props.risk.area.name}</div>
                        </div>
                    </div>

                    {this.props.risk.opportunities && (
                        <div className="rk-info-grid rk-info-grid--bottom" style={{ gridTemplateColumns: "1fr", marginTop: 18 }}>
                            <div className="rk-info-field">
                                <div className="rk-info-field__label">Oportunidades</div>
                                <div className="rk-info-field__value" style={{ whiteSpace: "pre-line" }}>{this.props.risk.opportunities}</div>
                            </div>
                        </div>
                    )}
                </div>

                {/* ===== Tabs Tareas / Comentarios ===== */}
                <div className="rk-tabs">
                    <button
                        className={`rk-tabs__btn ${this.state.activeTab === 'tareas' ? 'is-active' : ''}`}
                        onClick={() => this.setState({ activeTab: 'tareas' })}
                    >
                        <i className="fas fa-tasks"></i> Tareas
                    </button>
                    <button
                        className={`rk-tabs__btn ${this.state.activeTab === 'comentarios' ? 'is-active' : ''}`}
                        onClick={() => this.setState({ activeTab: 'comentarios' })}
                    >
                        <i className="far fa-comments"></i> Comentarios
                    </button>
                </div>

                {this.state.activeTab === 'tareas' && (
                    <div className="content main-card mb-3 card">
                        <div className="card-body">
                            {this.props.risk.task_board ? (
                                <IndexTaskModule
                                    task_board={this.props.risk.task_board}
                                    user={this.props.user}
                                    users={this.props.users}
                                    estados={this.props.estados}
                                    procesos={this.props.procesos}
                                    columns={this.props.columns}
                                    labels={this.props.labels}
                                    tasks={this.props.tasks}
                                    task_sources={this.props.task_sources}
                                    company={this.props.company}
                                    imageUpload={this.props.imageUpload}
                                    key_text={this.props.key_text}
                                />
                            ) : (
                                <div className="text-center p-4 text-muted">Preparando el tablero…</div>
                            )}
                        </div>
                    </div>
                )}

                {this.state.activeTab === 'comentarios' && (
                    <GeneralComments
                        usuario={this.props.user}
                        module_name={"Riesgos"}
                        users={this.state.users}
                        module_comment={this.props.risk.module_comment_id}
                        url={this.props.url}
                    />
                )}

            </React.Fragment>
        );
    }
}

export default ShowMejora;